import { App } from 'vue';
import Splitpanes from './Splitpanes.vue';
import Pane from './Pane.vue';

export default function config(app: App): void {
    app.component('Splitpanes', Splitpanes);
    app.component('Pane', Pane);
}